import { MacrosMenu } from '../../../macros/MacrosMenu';
import { jsx as _jsx } from "react/jsx-runtime";
export const useMacrosConfig = ({
  macrosEnabled,
  onSelectMacro
}) => {
  if (!macrosEnabled) {
    return {};
  }
  return {
    MACROS: {
      renderMacrosMenu: () => /*#__PURE__*/_jsx(MacrosMenu, {
        onSelectMacro: onSelectMacro
      })
    }
  };
};